import { ButtonGroup, DropdownButton } from "react-bootstrap";
import { FaCode } from "react-icons/fa";

export default function DevMenuButton(props) {
    return (
        <DropdownButton
            className={props.className}
            variant="outline-secondary"
            as={ButtonGroup}
            title={<FaCode style={{ marginTop: "-2px" }} />}
        >
            {props.children}
        </DropdownButton>
    );
}
